import React from 'react';
import {StyleSheet, Text, View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import BasePopover from '/component/base/Popover';

const styles = StyleSheet.create({
  messageContainer: {
    marginBottom: 20,
  },
  buttonContainer: {
    paddingHorizontal: '25%',
  },
});

interface DummyProps {
  popoverClose: () => void;
  message: string;
}

const Dummy: React.FC<DummyProps> = ({popoverClose = noop, message = ''}) => {
  return (
    <BasePopover padded={true}>
      <View style={styles.messageContainer}>
        <Text>Message: {message}</Text>
      </View>
      <View style={styles.buttonContainer}>
        <Button onPress={popoverClose}>Close Popover</Button>
      </View>
    </BasePopover>
  );
};

export default Dummy;
